import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Users2 } from "lucide-react";
import { api } from "@/lib/api";
import { PageMasthead } from "@/components/ui-custom/PageMasthead";
import { RevealStagger, staggerItem } from "@/components/ui-custom/RevealOnScroll";
import { COMMITTEE_PHOTO_MAP } from "@/lib/committeePhotos";

const PROMINENT = ["Presiden", "Timbalan Presiden", "Setiausaha", "Bendahari"];

function LeaderCard({ m, prominent }) {
  const photo = COMMITTEE_PHOTO_MAP[m.display_name];
  return (
    <motion.div variants={staggerItem} className="group" data-testid={`committee-member-${m.id}`}>
      <div
        className={`relative rounded-2xl overflow-hidden mb-4 bg-white border border-piks-border transition-transform duration-300 group-hover:-translate-y-1 ${
          prominent ? "aspect-[3/4]" : "aspect-square"
        }`}
      >
        {photo ? (
          <img src={photo} alt={m.display_name} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-piks-ivory">
            <span className="font-display text-3xl text-piks-black">{m.display_name?.[0]}</span>
          </div>
        )}
        <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="absolute bottom-0 left-0 h-[3px] w-0 group-hover:w-full bg-piks-gold transition-all duration-300" />
      </div>
      <p className="font-semibold text-piks-black">{m.display_name}</p>
      <p className="text-xs text-piks-red font-medium tracking-wide mt-0.5">{m.position.toUpperCase()}</p>
    </motion.div>
  );
}

export default function Kepimpinan() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/public/committee").then((r) => setData(r.data)).catch(() => {});
  }, []);

  const members = data?.members || [];
  const topRow = members.filter((m) => PROMINENT.includes(m.position));
  const restRow = members.filter((m) => !PROMINENT.includes(m.position));

  return (
    <div data-testid="kepimpinan-page">
      <PageMasthead breadcrumb="KEPIMPINAN" title="Kepimpinan" subtitle={data?.term?.name} />

      <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        {!data || members.length === 0 ? (
          <div className="text-center py-16 text-piks-muted" data-testid="kepimpinan-empty-state">
            <Users2 className="w-10 h-10 mx-auto mb-3 opacity-40" />
            Maklumat jawatankuasa belum tersedia.
          </div>
        ) : (
          <>
            <RevealStagger className="grid grid-cols-2 sm:grid-cols-4 gap-6 mb-14" staggerDelay={0.08}>
              {topRow.map((m) => (
                <LeaderCard key={m.id} m={m} prominent />
              ))}
            </RevealStagger>
            {restRow.length > 0 && (
              <RevealStagger className="grid grid-cols-2 sm:grid-cols-3 gap-6" staggerDelay={0.06}>
                {restRow.map((m) => (
                  <LeaderCard key={m.id} m={m} />
                ))}
              </RevealStagger>
            )}
          </>
        )}
      </section>
    </div>
  );
}
